<template>
  <div class="manage">
    <div>
      <el-row class="content">
        <el-col :span="6" class="left">
          <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"
                   ref="tree" highlight-current default-expand-all>
          </el-tree>
        </el-col>

        <el-col :span="18" class="right">
          <div class="right-header">
            <el-button type="primary" size="mini" @click="addTopArea()" :disabled="!hasCommitPermission">添加区域</el-button>
            <el-button type="success" size="mini" @click="addSubArea()" :disabled="subAreaEnable || !hasCommitPermission">添加子区域</el-button>
          </div>

          <div class="right-desc">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="name" label="区域名称">
                <template v-slot="scope">
                  <el-tag>{{ scope.row.name }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="comments" label="区域说明">
              </el-table-column>

              <el-table-column v-if="subAreaEnable" prop="address" label="区域地址">
              </el-table-column>

              <el-table-column prop="state" label="区域状态" width="90px">
                <el-tag type="warning">正常</el-tag>
              </el-table-column>

              <el-table-column v-if="subAreaEnable" prop="verify" label="区域验证" width="80px">
                <template v-slot="scope">
                  <el-switch
                      @change="onTableSwitchChange(scope.row)"
                      v-model="scope.row.verify" active-value="1" inactive-value="0">
                  </el-switch>

                </template>
              </el-table-column>

              <el-table-column label="操作" width="150px">
                <template v-slot="scope">
                  <el-button type="success" size="mini" @click="tableUpdate(scope.row)">修 改</el-button>
                  <el-button type="danger" size="mini" @click="delSelectArea(scope.row)" :disabled="!hasCommitPermission">删 除</el-button>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-drawer :visible.sync="drawer">
      <el-form :model="form" ref="form" :rules="rules" class="edit-form">
        <div class="header-content" v-if="formType === 'sub'">
          {{ selectedValue }}
        </div>

        <div class="main-content">
          <el-form-item v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label + ':'">
            <el-input :placeholder="'请输入' + item.label" v-model="form[item.prop]"></el-input>
          </el-form-item>
          <template v-if="drawerShowSwitch">
            <el-form-item label="区域验证:">
              <el-switch
                  v-model="form.verify" active-value="1" inactive-value="0" active-text="打开" inactive-text="关闭">
              </el-switch>
            </el-form-item>
          </template>
        </div>


        <div class="footer-content">
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit" :disabled="!hasCommitPermission">确认</el-button>
            <el-button size="mini" @click="drawer = false">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import {addArea, delArea, getAllArea, updateArea} from "@/api/device-manager-api";

export default {
  name: "AreaMgrImpl",
  data() {
    return {
      rules: {
        name: [
          {required: true, message: '请输入区域名称', trigger: 'change'},
          // { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ]
      },
      tableData: [],
      treeData: [],
      defaultProps: {
        children: 'areas',
        label: 'name'
      },
      selectNode: null,

      drawer: false,
      formType: "",
      drawerShowSwitch: false,
      selectedValue: "",
      form: {},
      formLabel: [
        {
          prop: 'name',
          label: '区域名称'
        },
        {
          prop: 'comments',
          label: '区域描述'
        }
      ],
      subAreaEnable: true,
    }


  },// end data
  mounted() {
    this.loadAreaData()
  },
  methods: {
    loadAreaData() {
      getAllArea().then(({data}) => {
        console.log("data => ", data)
        if (data.code === 200) {
          this.treeData = data.data
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    handleNodeClick(data) {
      console.log("data =>", data)
      this.tableData = []
      this.tableData.push({
        id: data.id,
        name: data.name,
        comments: data.comments,
        state: "正常",
        address: data.address,
        parentId: data.parentId,
        verify: data.verify ? "1" : "0"
      })
      this.selectNode = data
      this.subAreaEnable = data.parentId !== -1;
    },

    addTopArea() {
      this.formType = "top"
      this.formLabel = []
      this.formLabel.push({prop: 'name', label: '区域名称'})
      this.formLabel.push({prop: 'comments', label: '区域描述'})
      this.form = {}
      this.drawerShowSwitch = false
      this.drawer = true
    },

    addSubArea() {
      if (this.selectNode == null) {
        this.$message.error('请选择子区域所在的上级区域');
        return
      }
      this.formType = "sub"
      this.formLabel = []
      this.formLabel.push({prop: 'name', label: '子区域名称'})
      this.formLabel.push({prop: 'comments', label: '子区域概述'})
      this.formLabel.push({prop: 'address', label: '子区域地址'})
      this.selectedValue = "上级区域：" + this.selectNode.name
      this.form = {}
      this.drawerShowSwitch = true
      this.drawer = true
    },

    delSelectArea() {
      if (this.selectNode == null) {
        this.$message.error('请选择要删除的区域');
        return
      }
      delArea(this.selectNode.id).then(({data}) => {
        if (data.code === 200) {
          this.loadAreaData() // 刷新区域树
          this.tableData = [] // 清空区域列表
          this.$message.success('删除成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error => ", error)
        this.showNetErrMsg();
      })
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.formType === "update") {
            this.onSubmitUpdate()
          } else {
            this.onSubmitAdd()
          }
        } else {
          console.log('validate error, error submit!!');
          return false;
        }
      });
    },

    onSubmitUpdate() {
      console.log("this.form =>", this.form)

      updateArea(this.form).then(({data}) => {
        console.log("updateArea data =>", data)
        if (data.code === 200) {
          this.tableData = []

          this.tableData.push({
            "id": data.data.id,
            "name": data.data.name,
            "comments": data.data.comments,
            "address": data.data.address,
            "parentId": data.data.parentId,
            "state": "正常",
            "verify": data.data.verify.toString()
          })
          let node = this.selectNode
          node.name = data.data.name
          node.comments = data.data.comments

          this.form = {}
          this.drawer = false
          this.loadAreaData()
          this.$message.success('修改成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((err) => {
        console.log("updateArea", "err =>", err)
        this.showNetErrMsg();
      })

    },

    onSubmitAdd() {
      if (this.formType === "sub") {
        let selectedNode = this.selectNode

        this.form.parentId = selectedNode.id
      } else {
        this.form.parentId = -1
      }

      addArea(this.form).then(({data}) => {
        // console.log("data =>", data)

        if (data.code === 200) {
          this.loadAreaData()

          this.drawer = false
          this.$message.success('添加成功');
        } else if (data.code === 700) {
          if (this.form.parentId === -1) {
            this.$message.error(data.data.name + " 区域已经存在");
          } else {
            this.$message.error(data.data.parentName + " 已经存在子区域 " + data.data.name);
          }
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((error) => {
        console.log("error => ", error)
        this.showNetErrMsg();
      })
    },

    tableUpdate(row) {
      this.formType = "update"
      this.formLabel = []

      this.formLabel.push({prop: 'name', label: '区域名称'})
      this.formLabel.push({prop: 'comments', label: '区域概述'})

      // console.log("row =>", row)
      this.form = {
        "id": row.id,
        "name": row.name,
        "comments": row.comments,
        "parentId": row.parentId,
        "verify": row.verify
      }
      if (row.parentId !== -1) {
        this.formLabel.push({prop: 'address', label: '区域地址'})

        this.$set(this.form, "address", row.address)
        this.drawerShowSwitch = true
      } else {
        this.drawerShowSwitch = false
      }

      this.drawer = true
    },
    onTableSwitchChange(row) {
      let updataData = {
        "id": row.id,
        "parentId": row.parentId,
        "verify": row.verify
      }
      console.log("@@@", updataData)
      updateArea(updataData).then(({data}) => {
        console.log("updateArea data =>", data)
        if (data.code === 200) {
          this.tableData = []

          this.tableData.push({
            "id": data.data.id,
            "name": data.data.name,
            "comments": data.data.comments,
            "address": data.data.address,
            "state": "正常",
            "parentId": data.data.parentId,
            "verify": data.data.verify.toString()
          })
          let node = this.selectNode
          node.name = data.data.name
          node.comments = data.data.comments

          this.form = {}
          this.drawer = false

          this.$message.success('修改成功');
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch((err) => {
        console.log("updateArea", "err =>", err)
        this.showNetErrMsg();
      })


    }
  },// methods
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("EMPLOYEE_MANAGE_MODIFY")
        default:
          return false
      }
    }
  },

}

</script>

<style scoped lang="less">
.manage {

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;

    .header-content {
      margin-bottom: 20px;
    }

    .main-content {
      flex: 1 0 auto;

      .el-form-item {
        display: flex;
        justify-content: flex-start;

        /deep/ .el-form-item__label {
          width: 100px;
        }

        /deep/ .el-input {
          width: calc(20vw);
        }
      }
    }

    .footer-content {
      text-align: center;
      flex: 0 0 auto;
    }
  }

  .content {
    display: flex;
    justify-content: space-between;

    .left {
      margin: 20px 20px 20px 0;

      //border-left: 1px solid #efefef;
      border-right: 1px solid #efefef;
      box-shadow: 2px 2px 2px 2px #efefef;
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      margin-top: 20px;
      margin-bottom: 20px;
      margin-right: 20px;

      .right-header {
        display: flex;
        justify-content: flex-start;

        margin-bottom: 20px;
      }

      .right-desc {
        /deep/ .el-table__body-wrapper {
          height: calc(100vh - 260px);
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
          /*width: 0;宽度为0隐藏*/
          width: 0;
        }
      }
    }
  }
}
</style>
